var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.44 15.37C17.25 15.37 17.06 15.3 16.91 15.15C16.62 14.86 16.62 14.38 16.91 14.09L18.94 12.06L16.91 10.03C16.62 9.74 16.62 9.26 16.91 8.97C17.2 8.68 17.68 8.68 17.97 8.97L20.53 11.53C20.82 11.82 20.82 12.3 20.53 12.59L17.97 15.15C17.82 15.3 17.63 15.37 17.44 15.37Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.93 12.81H9.76001C9.35001 12.81 9.01001 12.47 9.01001 12.06C9.01001 11.65 9.35001 11.31 9.76001 11.31H19.93C20.34 11.31 20.68 11.65 20.68 12.06C20.68 12.47 20.34 12.81 19.93 12.81Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.76 20.75C6.61001 20.75 3.01001 17.15 3.01001 12C3.01001 6.85 6.61001 3.25 11.76 3.25C12.17 3.25 12.51 3.59 12.51 4C12.51 4.41 12.17 4.75 11.76 4.75C7.49001 4.75 4.51001 7.73 4.51001 12C4.51001 16.27 7.49001 19.25 11.76 19.25C12.17 19.25 12.51 19.59 12.51 20C12.51 20.41 12.17 20.75 11.76 20.75Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.32084b4368594655aded45b8a6a0d973.svg";
export { ForwardRef as ReactComponent };